"use client";

import { twMerge } from "tailwind-merge";

import { NormalText } from "@/components/text/NormalText";
import { allGenreFilters } from "@/constants/selectArtistFilters";
import { useNamedSelectArtistFilters } from "@/lib/zustand/useSelectArtistFilters";
import { classNames } from "@/utils/classNames";

export function GenreFilterPart({
  namespace,
  className,
}: {
  namespace: string;
  className?: string;
}) {
  const useSelectArtistFilters = useNamedSelectArtistFilters((state) =>
    state.getNamedStore(namespace)
  );
  const genreFilterShow = useSelectArtistFilters(
    (state) => state.genreFilterShow
  );
  const toggleGenreFilterShow = useSelectArtistFilters(
    (state) => state.toggleGenreFilterShow
  );

  const allGenresSelected = allGenreFilters.every((genre) =>
    genreFilterShow.has(genre)
  );

  return (
    <div className={twMerge("", className)}>
      <NormalText elementType="p" className="mb-1 text-gray-400">
        TAGS
      </NormalText>
      <div className="flex flex-wrap gap-2">
        {allGenreFilters.map((genre) => (
          <button
            data-tutorial={`genre-filter-${genre}`}
            key={genre}
            className={classNames(
              genreFilterShow.has(genre) && !allGenresSelected ?
                "border-primary bg-primaryLight"
              : "border-gray-400 bg-white",
              "rounded-md border transition-colors"
            )}
            onClick={() => {
              toggleGenreFilterShow(genre);
            }}
          >
            <NormalText
              elementType="span"
              className={classNames(
                genreFilterShow.has(genre) && !allGenresSelected ?
                  "text-gray-900"
                : "text-gray-400",
                "px-1 py-0.5 transition-colors"
              )}
            >
              {genre}
            </NormalText>
          </button>
        ))}
      </div>
    </div>
  );
}
